export default ({keys, server}) => `package com.stripe.example

import android.app.Application
import androidx.lifecycle.ProcessLifecycleOwner
import com.stripe.stripeterminal.TerminalLifecycleObserver

{+lifecycle}
class StripeTerminalApplication : Application() {
    private val observer: TerminalLifecycleObserver = TerminalLifecycleObserver.getInstance()

    override fun onCreate() {
        super.onCreate()

        // If you already have a class that extends 'Application',
        // put whatever code you had in the 'onCreate' method here.

        registerActivityLifecycleCallbacks(observer)
        ProcessLifecycleOwner.get().lifecycle.addObserver(observer)
    }

    override fun onTrimMemory(level: Int) {
        super.onTrimMemory(level)

        // If you already have a class that extends 'Application',
        // put whatever code you had in the 'onCreate' method here.

        observer.onTrimMemory(level, this)
    }
}
{/lifecycle}
`;
